import React from 'react'
import { ChallengeService } from '@duck/api-definitions'
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@duck/ui'
import { useTar } from '@/modules'
import { FeedbackContent, SolutionContent } from '@/components/FeedbackDialog/content'

interface ChallengeContentTabsProps {
  challengeInfo: ChallengeService.ChallengeInfo
}

const EmptyTabState: React.FC<{ textKey: Parameters<ReturnType<typeof useTar>['t']>[0] }> = ({ textKey }) => {
  const { t } = useTar()
  return (
    <p className="text-muted-foreground text-center py-8">{t(textKey)}</p>
  )
}

export const ChallengeContentTabs: React.FC<ChallengeContentTabsProps> = ({ challengeInfo }) => {
  const { t } = useTar()
  const { challenge } = challengeInfo

  const isProcessed = challenge.feedbackStatus === ChallengeService.FeedbackStatusEnum.Processed
  const hasEmployerFeedback = Boolean(
    challenge.employerFeedback &&
    (challenge.employerFeedback.feedback || challenge.employerFeedback.grade != null)
  )

  const defaultTab = isProcessed ? 'feedback' : hasEmployerFeedback ? 'employer' : 'submission'

  return (
    <Tabs defaultValue={defaultTab}>
      <TabsList className="flex w-full h-auto min-h-12">
        <TabsTrigger value="feedback" className="flex-1 min-w-0 h-auto min-h-8 whitespace-normal text-center leading-tight text-xs sm:text-sm">{t('challenges.feedbackTab')}</TabsTrigger>
        <TabsTrigger value="employer" className="flex-1 min-w-0 h-auto min-h-8 whitespace-normal text-center leading-tight text-xs sm:text-sm">{t('challenges.employerFeedback')}</TabsTrigger>
        <TabsTrigger value="submission" className="flex-1 min-w-0 h-auto min-h-8 whitespace-normal text-center leading-tight text-xs sm:text-sm">{t('challenges.submission')}</TabsTrigger>
      </TabsList>
      <div className="mt-3">
        <TabsContent value="feedback">
          {isProcessed ? (
            <FeedbackContent challenge={challengeInfo} showEmployer={false} showChallengeDetails={false} />
          ) : (
            <EmptyTabState textKey="challenges.detailNoFeedback" />
          )}
        </TabsContent>
        <TabsContent value="employer">
          {hasEmployerFeedback ? (
            <FeedbackContent challenge={challengeInfo} showEmployer showChallengeDetails={false} />
          ) : (
            <EmptyTabState textKey="challenges.detailNoEmployerFeedback" />
          )}
        </TabsContent>
        <TabsContent value="submission">
          <SolutionContent workState={challenge.workState} className="h-full" />
        </TabsContent>
      </div>
    </Tabs>
  )
}
